export const CustomerTypePolicy = ({

    SL: "SL",
    AGENT: "Agent",
    SHIPPER: "Shipper",
    CONSIGNEE: "Consignee",
    BOTH: "Both",
    CC: "CC",

})